<template>
  <div :class="['container', 'default-select-wrapper', `${page_style}`]">
    <div :class="isNewFunnelClass" @click="showPicker">
      <div v-if="isNewFunnel && cm" class="img-wrapper">
        <img-v3 :src="doc_icon_url" class="icon-img" />
      </div>
      <span class="title">{{formItem.title}}</span>
      <p class="select-input">
        <span :class="['value-input', {'in-value': formatValue}]">{{formatValue}}</span>
        <span :class="['info-arrow', `info-arrow-${location_country}`, cm && !formatValue ? 'info-arrow-audit-init' : '']"></span>
      </p>
    </div>
    <div class="el-default-select-wrapper">
      <el-select
        v-if="isFleetPCFunnel"
        v-model="selectValue"
        filterable
        :placeholder="' '"
        :no-match-text="' '"
        :no-data-text="' '"
        class="el-default-select"
        @change="elSelectChange">
        <el-option
          v-for="item in selectOptions"
          :key="item.value"
          :label="item.text"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <p
      :class="['status-tip','tip_'+formItem.field_status]"
      v-show="formItem.field_result && !cm"
    >{{formItem.field_result}}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { emitFormUpdate } from "../../tools/utils";
import { post } from "../../tools/request";
import defaultImg from "../../images/icon_document_default.png";
import uploadedImg from "../../images/icon_document_uploaded.png";
import approvedImg from "../../images/icon_document_approved.png";
import blockedImg from "../../images/icon_document_blocked.png";
export default {
  props: ["formItem", "idx", "cm", "page_style"],
  data() {
    return {
      selectValue: '',
      iconImg: require('../../images/icon_document_default.png'),
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    selectOptions() {
      return Array.isArray(this.formItem.options) ? this.formItem.options : []
    },
    formatValue() {
      let finded = this.selectOptions.find(
        x => x.value == this.formItem.value
      );
      return finded ? finded.text : "";
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    isNewFunnel() {
      return ["h5_funnel", "h5_funnel_fleet"].includes(this.page_style);
    },
    // 列表页新样式
    isNewFunnelClass() {
      return (this.isNewFunnel && this.cm) ? 'new-funnel' : 'select-wraper'
    },
    doc_icon_url() {
      let imgMap = {
        0: defaultImg,
        1: defaultImg,
        2: defaultImg,
        3: uploadedImg,
        4: approvedImg,
        5: blockedImg,
      };
      return imgMap[this.formItem.field_status] || defaultImg;
    },
  },
  mounted() {
    if ("" + this.formatValue) {
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      // 给PC端组件赋默认值
      this.selectValue = this.formatValue
    }
  },
  methods: {
    showPicker() {
      //已通过则不再允许做操作
      if (this.formItem.field_status == 4) {
        return;
      }
      // 处理数据有问题的情况
      if (!Array.isArray(this.formItem.options)) {
        return;
      }
      if (!this.picker) {
        //处理当前选择项，初始化
        let curIdx = this.formItem.options.findIndex(
          x => x.value == this.formItem.value
        );
        //兼容val为0的情况
        if ("" + this.formItem.value) {
          this.formItem.valid = true;
          emitFormUpdate(this, this.idx);
        }

        this.picker = this.$createPicker({
          data: [this.formItem.options],
          selectedIndex: curIdx == -1 ? [] : [curIdx],
          cancelTxt: this.$t("取消"),
          confirmTxt: this.$t("确认"),
          onSelect: this.checkCommit
        });
      }
      if (!this.isFleetPCFunnel) {
        this.picker.show();
      }
    },
    elSelectChange(v) {
      // pc端的组件
      console.log(v)
      this.setValue(v);
    },
    checkCommit(...a) {
      //mobile的组件
      //a 为当前选中项的值，默认1列
      let v = a[0][0];
      this.setValue(v);
    },
    setValue(v) {
      this.formItem.value = v;
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      //if need add
      if (this.cm) {
        this.addInfo();
      }
    },
    //提交物料
    addInfo() {
      // 更新icon --checking
      this.formItem.field_status = 3;
      this.formItem.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
          this.$emit('reloadConfig', 'reload')
        })
        .catch(err => {
          this.formItem.field_status = 5;
          this.formItem.field_result = err.errmsg;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
}
.status-tip {
  width: 7.1rem; //铺满右侧
  margin-right: 0;
}

// 新样式
.default-select-wrapper.h5_funnel_fleet,
.default-select-wrapper.h5_funnel {
  .new-funnel {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  width: 100%;
  min-height: 1.76rem;
  border-bottom: 1px solid #eeeeee;
  .img-wrapper {
    width: 0.96rem;
    height: 0.96rem;
    margin-right: 0.24rem;
    flex-shrink: 0;
  .icon-img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    // margin-bottom: 0.5rem;
    line-height: 0.48rem;
    font-size: 0.32rem;
    color: #333333;
    font-weight: 700;
  }
  .select-input {
    margin-right: 0;
    margin-left: auto;
  }
  .info-arrow {
        border-right-color: #999;
        border-bottom-color: #999;
  }
  p {
    color: #323233;
    .info-arrow {
      margin-bottom: 1px;
      // &.info-arrow-audit-init {
      //   border-right: 2px solid #ff7226;
      //   border-bottom: 2px solid #ff7226;
      // }
      // &.info-arrow-audit-init.info-arrow-BR {
      //   border-right: 2px solid #2697ff;
      //   border-bottom: 2px solid #2697ff;
      // }
    }
  }
}
}
.select-wraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 1.4rem;

  p {
    color: #323233;
    .info-arrow {
      margin-bottom: 1px;
      &.info-arrow-audit-init {
        border-right: 2px solid #ff7226;
        border-bottom: 2px solid #ff7226;
      }
      &.info-arrow-audit-init.info-arrow-BR {
        border-right: 2px solid #2697ff;
        border-bottom: 2px solid #2697ff;
      }
    }
  }
}


.default-select-wrapper.h5_funnel_fleet,
.default-select-wrapper.h5_funnel_fleet_pc {
  .select-wraper {
    flex-direction: column;
    justify-content: center;
    align-items: normal;
    .title {
      font-size: .24rem;
      color: #666666;
      font-weight: 500;
      line-height: 0.26rem;
    }
    .select-input {
      display: flex;
      justify-content: space-between;
      padding: 0.32rem 0;
      width: 100%;
      max-width: 100%;
      border-bottom: 0.01rem solid #EEEEEE;
      transform: none;
      .value-input {
        font-size: .32rem;
        color: #333333;
        font-weight: 700;
        color: #CCCCCC;
      }
      .in-value {
        color: #333333;
      }
      .info-arrow {
        border-right-color: #666666;
        border-bottom-color: #666666;
      }
    }
  }
}
.default-select-wrapper.h5_funnel_fleet_pc {
  position: relative;
  padding: 0 32px 0 32px;
  .select-wraper {
    min-height: 76px;
    .title {
      font-size: 12px;
      line-height: 13px;
      font-weight: 500;
    }
    .select-input {
      padding: 16px 0;
      border-bottom: 1px solid #EEEEEE;
      .value-input {
        font-size: 16px;
        font-weight: 700;
        opacity: 0;
      }
    }
  }
}
.el-default-select-wrapper {
  position: relative;
  width: 100%;
  .el-default-select {
    width: 100%;
    position: absolute;
    bottom: 8px;
    // opacity: 0;
    ::v-deep .el-input {
      margin-bottom: 16px;
      input {
          height: 20px;
          padding: 0;
          font-size: 16px !important;
          font-weight: 700;
          border: none;
          background: transparent;
          color: #333333;
      }
      input::placeholder {
        color: #CCCCCC;
      }
      .el-input__suffix {
          display: none;
      }
    }
  }
}

</style>

